import type { Metadata } from "next";
import { ALL_APP_LOCALES, type AppLocale } from "@/lib/i18n/constants";
import type { FeatureFlagEnv } from "@/lib/feature-flags";

const BASE_INDEXABLE_LOCALES: readonly AppLocale[] = ALL_APP_LOCALES;

export const INDEXABLE_LOCALES: AppLocale[] = getIndexableLocales();

export function getIndexableLocales(env: FeatureFlagEnv = process.env): AppLocale[] {
  void env;

  return [...BASE_INDEXABLE_LOCALES];
}

export function isIndexableLocale(locale: string, env: FeatureFlagEnv = process.env): locale is AppLocale {
  return getIndexableLocales(env).some((indexableLocale) => indexableLocale === locale);
}

export function robotsForLocale(locale: string, env: FeatureFlagEnv = process.env): Metadata["robots"] {
  return isIndexableLocale(locale, env)
    ? {
        index: true,
        follow: true,
        "max-image-preview": "large",
      }
    : {
        index: false,
        follow: false,
      };
}

